<template>
  <div>
    <div class="container bg-light my-3 py-3 px-4">
      
      <div class="row">
        <div class="col-12">
          <h2 class="ms-4 text-start">Edit user</h2>
          <hr>
        </div>
      </div>

      <div class="row mt-3"> 
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            label="Enter User First Name"
            :placeholder="user.name"
            :initialValue="user.name"
            @input="(e) => this.user.name = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            label="Enter User Lastname"
            placeholder="Lastname"
            :initialValue="user.lastname"
            @input="(e) => this.user.lastname = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="email"
            label="Enter user email"
            placeholder="Email"
            :initialValue="user.email"
            @input="(e) => this.user.email = e.target.value"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="password"
            label="Enter user Password"
            placeholder="Password"
            @input="(e) => this.user.password = e.target.value"
          />
        </div>
      </div>
      <div class="row mt-3" v-if="showErrorPasswordLength">
        <div class="col-12 col-lg-6">
          Minimum password length is 8 characters
        </div>
      </div>
      <div class="row mt-3" v-if="showErrorLowerLetter">
        <div class="col-12 col-lg-6">
          Require at least one lowercase letter from Latin alphabet (a-z)
        </div>
      </div>
      <div class="row mt-3" v-if="showErrorCapitalLetter">
        <div class="col-12 col-lg-6">
          Require at least one uppercase letter from Latin alphabet (A-Z)
        </div>
      </div>
      <div class="row mt-3" v-if="showErrorNumber">
        <div class="col-12 col-lg-6">
          Require at least one number
        </div>
      </div>
      <div class="row mt-3" v-if="showErrorSpecialChar">
        <div class="col-12 col-lg-6">
          Require at least one non-alphanumeric character (! @ # $ % ^ & * ( ) _ + - = [ ] { } | ')
        </div>
      </div>

      <div class="row mt-3"> 
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            label="Enter Username"
            placeholder="Username"
            :initialValue="user.username"
            @input="(e) => this.user.username = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-multiselect
            ref="sites-multiselect"
            :initialValue="initialSites"
            placeholderToTag="Add"
            placeholder="Smartmatic apps"
            name="name"
            label="Grant this user permision to smartmatic services"
            :optionsToSelect="sitesToAdd"
            @handleAddTagging="addSite"
          />
        </div>
      </div>

      <div class="row mt-3"
        v-for="site in selectedSites" :key="site.code"
      >
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            :label="`Enter Username for ${site.name}`"
            :placeholder="
              site.username
                ? `${site.username} is the current username for this user in ${site.name}` 
                : `Enter an username for ${site.name}`
            "
            :initialValue="site.username ? site.username : ''"
            @change="handleUsernameInput($event, site.code)"
            @unMounted="handleUsernameDelete($event, site.code)"
          />
        </div>
      </div>

      <div v-if="user.email !== loggedUser.email" class="row mt-3">
        <div class="col-12 col-lg-6">

          <input 
            type="checkbox" 
            class="btn-check" 
            id="edit_user_admin_checkbox" 
            :value="user.is_admin"
            v-model="user.is_admin"
          >
          <label
            class="btn btn-outline-primary" 
            for="edit_user_admin_checkbox"
          >
            Admin
          </label>

        </div>
      </div>

      <div class="row mt-4">
        <div class="col-6 col-lg-3">
          <button 
            class="btn btn-outline-primary w-100" 
            @click="goBack"
          >
            Dismiss
          </button>
        </div>
        <div class="col-6 col-lg-3">
          <button
            class="btn btn-primary w-100"
            :disabled="disableEditButton"
            @click="handleEditUser"
          >
            Edit User
          </button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import caSmttInput from '../../components/ca-smtt-input.vue'
import CaSmttMultiselect from '../../components/ca-smtt-multiselect.vue'
import { getUserById, updateUser } from '@/services/users/user.api.js'
import { getSites } from '@/services/sites/site.api.js'

export default {
  data() {
    return {
      user: {
        name: null,
        lastname: null,
        username: null,
        email: null,
        sites: [],
        is_admin: false,
      },
      initialSites:  [],
      sitesToAdd: [],
      selectedSites: [],
    }
  },
  components: { caSmttInput, CaSmttMultiselect },
  async mounted() {
    await this.getSitesData()
    await this.getUserData()
    this.$watch(
      () => {
        return [this.$refs['sites-multiselect'].value]
      },
      ([sitesToAdd]) => {
        this.selectedSites = sitesToAdd
      }
    );
  },
  computed: {
    loggedUser() {
      return this.$store.state.user
    },
    editingUserId() {
      return this.$route.params.id
    },
    usernameSitesOK() {
      return (
        (this.selectedSites.length === this.user.sites.length) && this.user.sites.every(site => site.usernameSite)
      )
    },
    disableEditButton() {
      return (
        !this.user.name 
        || !this.user.lastname 
        || !this.user.username 
        || !this.user.email
        || !this.usernameSitesOK
      )
    },
    showErrorPasswordLength() {
      if(this.user.password) {
        return this.user.password.length < 8;
      }
      return false;
    },
    showErrorCapitalLetter() {
      if(this.user.password) {
        const regex = /^(?=\S*[A-Z])/;
        return !regex.test(this.user.password);
      }
      return false;
    },
    showErrorLowerLetter() {
      if(this.user.password) {
        const regex = /^(?=\S*[a-z])/;
        return !regex.test(this.user.password);
      }
      return false;
    },
    showErrorSpecialChar() {
      if(this.user.password) {
        const regex = /^(?=\S*[^\w\s])/;
        return !regex.test(this.user.password);
      }
      return false;
    },
    showErrorNumber() {
      if(this.user.password) {
        const regex = /^(?=\S*\d)/;
        return !regex.test(this.user.password);
      }
      return false;
    },
  },
  methods: {
    async getSitesData() {
      try {
        const { data } = await getSites()
        this.sitesToAdd = data.sites.map(site => ({code: site.id, name: site.site}))
      } catch (error) {
        console.log(error)
      }
    },
    async getUserData(){
      try {
        const { data } = await getUserById(this.editingUserId)

        // setting user initial data
        this.user.name = data.user.name
        this.user.lastname = data.user.last_name
        this.user.email = data.user.email
        this.user.username = data.user.username
        this.user.is_admin = data.user.is_admin

        // set initial sites values
        this.initialSites = data.user.sites.map(site => (
          {code: site.id, name: site.site, username: site.user_sites.username_site}
        ))
        // set input fields for usernames
        this.selectedSites = this.initialSites

        // set initial site id and site username 
        this.user.sites = data.user.sites.map(site => (
          {siteId: site.id, usernameSite: site.user_sites.username_site}
        ))
      } catch (error) {
        console.log(error)
      }
    },
    addSite (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.sitesToAdd.push(tag)
      this.initialSites.push(tag)
    },
    handleUsernameInput(event, siteCode) {
      const siteFound = this.user.sites.find(site => site.siteId === siteCode)

      if (!siteFound) this.user.sites.push( { siteId: siteCode, usernameSite: event.target.value } )
      
      if (siteFound) {
        this.user.sites = this.user.sites.map(site => {
          if (site.siteId === siteFound.siteId) {
            site['usernameSite'] = event.target.value
          }
          return site
        })
      }
    },
    handleUsernameDelete(e, siteCode){
      this.user.sites = this.user.sites.filter(site => parseInt(site.siteId) !== siteCode)
    },
    async handleEditUser() {
      const regex = /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*[^\w\s])\S{8,}$/;
      if(this.user.password) {
        if(!regex.test(this.user.password)) {
          this.$toast.open({
            message: 'Invalid Password',
            type: 'error'
          })
          return;
        }
      }
      const user = {
        "name": this.user.name,
        "last_name": this.user.lastname,
        "email": this.user.email,
        "username": this.user.username,
        "sites": this.user.sites.map(site => ({ siteId: parseInt(site.siteId), usernameSite: site.usernameSite })),
        "password": this.user.password,
        "is_admin": this.user.is_admin,
      }
      
      try {
        await updateUser(this.editingUserId, user)

        // toast
        this.$toast.open({
          message: 'User Updated',
          type: 'success'
        })

        this.$router.back()
      } catch (error) {
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
        console.log(error)
      }
    },
    goBack() {
      this.$router.back()
    }
  } 
}
</script>